// =============================================================================
// permissions.js
// Centralised, database-driven permission checks.
//
// There are NO hardcoded role codes here. Whether a role grants administrative
// access is dictated entirely by its database attributes: the API derives an
// `is_admin` flag for each assignment from the role's
// `ur_custom_attributes.isDangerous` value. To grant or revoke admin rights,
// change the role in the database — no code change required.
//
// (The assignments are seeded into localStorage at login, so a user must log
// in again to pick up a role attribute change.)
// =============================================================================

const getAssignments = () => {
  try {
    return JSON.parse(localStorage.getItem('assignments') ?? '[]');
  } catch {
    return [];
  }
};

const adminFlag = (a) =>
  a?.is_admin === true || a?.ur_custom_attributes?.isDangerous === true;

// True if ANY of the signed-in user's role assignments is administrative.
// Falls back to reading the raw role attribute in case an older payload didn't
// include the server-computed flag.
export const isAdmin = () => getAssignments().some(adminFlag);

// True if the role the user is CURRENTLY ACTING AS is administrative.
//
// Different question to isAdmin(), and usually the one worth asking: someone
// who holds both an admin role and an operational one should not carry admin
// rights around while acting as the operational role. Signing in as "Plant
// Manager" should look like a plant manager's app.
//
// `urid` defaults to the selected role in localStorage, which is the same value
// the api interceptor sends as x-role-urid — so the screen and the request
// agree on who is asking.
export const isRoleAdmin = (urid = localStorage.getItem('roleUrid')) => {
  if (urid === null || urid === undefined || urid === '') return false;
  const want = String(urid);
  return getAssignments().some((a) => String(a?.urid) === want && adminFlag(a));
};

export default { isAdmin, isRoleAdmin };
